export function role_home_path(role_slug: string | undefined): string {
  if (role_slug === 'worker') {
    return '/employees/dashboard';
  }

  if (role_slug === 'partner') {
    return '/partners/company-products';
  }

  return '/clients/company-products';
}

export const ROUTER_COMPONENT_RELOAD_URL = '/employees/dashboard';
